// Plugins
import VueLazyload from 'vue-lazyload';

// Components
import VueMarkdown from '@adapttive/vue-markdown/src/VueMarkdown.js';
import Loader from 'shared/ui/components/Loader.vue';

// Directives
import CodeHighlight from 'ui/utils/directives/code-highlight';

export default {
    /** @param {import('vue').VueConstructor} app */
    install: (app) => {
        app.use(VueLazyload);

        const GLOBAL_COMPONENTS = {
            Loader: Loader,
            VueMarkdown: VueMarkdown
        };

        // Global components registration
        for (const componentName of Object.keys(GLOBAL_COMPONENTS)) {
            app.component(componentName, GLOBAL_COMPONENTS[componentName]);
        }

        app.directive('code-highlight', CodeHighlight);
    }
};
